import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { Loaderstyles } from "../utils/commonFunctions";
const CirculerLoader: React.FC = () => {
  return (
    <div style={Loaderstyles.loaderContainer}>
     <CircularProgress/>
    </div>
  );
};

export default CirculerLoader;
